<template>
  <div :class="generateClass">
    <hr>
  </div>
</template>
<script>
  import {generateClass} from  '../../../../mixins/baseComponets/generateClass'
  export default {
    name: 'BaseSeparator',
    props: {
      config: {type: Object, required: true},
    },
    mixins: [generateClass]
  }
</script>
